import { render } from "./PartnerLogin.vue?vue&type=template&id=b94c6edc&scoped=true"
import script from "./PartnerLogin.vue?vue&type=script&lang=js"
export * from "./PartnerLogin.vue?vue&type=script&lang=js"

import "./PartnerLogin.vue?vue&type=style&index=0&id=b94c6edc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94c6edc"]])

export default __exports__